/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.upgrade.management.rpc.UpgradeConfigInAppRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getAllUpgradeConfigsRpc = {
  serviceName: 'com.hubspot.upgrade.management.rpc.UpgradeConfigInAppRpc',
  rpcName: 'getAllUpgradeConfigs',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABxd8AABEOpCJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUpgradeConfigWithPurchaseMotionsRpc = {
  serviceName: 'com.hubspot.upgrade.management.rpc.UpgradeConfigInAppRpc',
  rpcName: 'getUpgradeConfigWithPurchaseMotions',
  auth: 'app',
  fingerprint: 'tGAGVi8wQP2XXznnDy3Iq5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};